import { BatchStatus } from '../../../domain/invoicing/invoicingApi'
import { hasBatchScope, scopeDateLabel, scopeDivisionsLabel, scopeWorkAreaStatusesLabel } from '../BatchCreate/batchScopeModel'
import { BatchMeta } from './batchMeta'

export const batchDrawerTitleSegments = (batchMeta?: BatchMeta, status?: BatchStatus): string[] => {
  const scope = {
    startDate: status?.startDate ?? batchMeta?.startDate,
    cutOffDate: status?.cutOffDate ?? batchMeta?.cutOffDate,
    divisionGroups: status?.divisionGroups ?? batchMeta?.divisionGroups,
    workAreaStatuses: status?.workAreaStatuses ?? batchMeta?.workAreaStatuses,
  }
  const segments: string[] = []

  if (hasBatchScope(scope)) {
    segments.push(`Date Range: ${scopeDateLabel(scope)}`)
    segments.push(`Divisions: ${scopeDivisionsLabel(scope)}`)
    segments.push(`Work Status: ${scopeWorkAreaStatusesLabel(scope)}`)
  }
  if (status?.totalJobs != null) {
    segments.push(`Total Jobs: ${status.totalJobs}`)
  }
  if (batchMeta?.requestedByUserName) {
    segments.push(`Created by: ${batchMeta.requestedByUserName}`)
  }

  return segments
}
